const initialState = {
  step: 0,
  firstName: '',
  lastName: '',
  email: '',
  country: {value: "United Arab Emirates", label: "United Arab Emirates"},
  countryCode: '',
  number: '',
  // country: {value: "92", label: "Pakistan"},
  // countryCode: '+92',
  //number: '3339603042',
  serverCode: '',
  code: '',
  password: '',
  confirmPassword: '',
  codeResend: true,
  countryList: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_STEP':
      return {...state, step: action.payload}
    case 'updateValues':
      return {...state, ...action.payload}
    default:
      return state
  }
}




// firstName: 'asdf',
// lastName: 'asdf',
// email: 'asdf@asd.com',
// country: '92',
// countryCode: '+92',
// number: '3339603042',
// serverCode: '3836',
// code: '3836',
// password: '123456',
// confirmPassword: '123456',
// codeResend: true,
// countryList: []
